
































import { WithConfirmModal } from '@/components/organisms/confirm-modal/with-confirm-modal'
import ConfirmModal from '@/components/organisms/ConfirmModal.vue'
import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import { ApiCreditcard } from '@/models/api/creditcard'
import { convertLongIdToDisplayId } from '@/models/api/id'
import { SelectOption, SelectOptionList } from '@/models/api/payment/parameter/type/user-select'
import { Payment, PaymentList } from '@/models/api/payment/payment'
import { PaymentType } from '@/models/app-config/behavior/types'
import { CartScopeEq } from '@/models/cart/group/scope'
import { convertFromStoreOrderHistoryToDiscountAmount } from '@/models/discount-amount/adapter/convert-from-store-order-history'
import { DiscountAmount } from '@/models/discount-amount/discount-amount'
import { iosCustomUrlSchemes } from '@/models/hl-app/custom-url-scheme'
import { Context, ContextFactory } from '@/models/order-history/status/context/context'
import PaymentService from '@/services/api/payment'
import { getCreditcardPaymentProvierServiceConfig } from '@/services/payment'
import CreateSelectOptionList from '@/services/payment/create-select-option-list'
import { ErrorBag } from '@/services/payment/options-validator'
import { CreditcardPayment } from '@/services/payment/types'
import { adCodeStore } from '@/util/adcode/store'
import { getIsBeforeCancellable } from '@spa/components/organisms/mypage/order/model/order-cancellation-state'
import PaymentEditViewModel, {
  PaymentEditViewModelFactory,
} from '@spa/components/organisms/order/edit/payment/model/payment-edit-view-model'
import PaymentEdit from '@spa/components/organisms/order/edit/payment/PaymentEdit.vue'
import { makePaymentParam } from '@spa/components/pages/mypage/order/reorder/interaction/payment-payload'
import {
  createTransferAuxDataOnReorder,
} from '@spa/components/pages/mypage/order/reorder/model/aux-data/create-transfer-aux-data-on-reorder'
import {
  filterPaymentMethodBasedOnOriginalOrder,
} from '@spa/components/pages/mypage/order/reorder/model/specification/payment-method/previous-payment-method-availability'
import { ReorderPaymentState } from '@spa/components/pages/mypage/order/reorder/model/state/reorder-payment-state'
import {
  AtoneError,
  atoneErrorMessages,
  parseAtoneErrorCodeAndMessage,
} from '@spa/components/pages/order/model/payment/atone-error'
import { AtoneScriptLoader, PaidyScriptLoader } from '@spa/components/pages/order/model/payment/payment-script-loader'
import { createRedirectHtmlRenderer } from '@spa/components/pages/order/order/redirect-html-renderer'
import { toQuery } from '@spa/components/pages/order/scope-transpiler'

import { log } from '@spa/log'
import { HlAppModeMixin } from '@spa/mixins/hl-app-mode'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { CommercePurchaseMenu, PurchaseService } from '@spa/services/api/purchase'
import { SellerSalesOrder } from '@spa/services/api/sellerSalesOrder'
import {
  atoneAuthenticatedCallbackFactory,
  atoneCancelledCallbackFactory,
  atoneErrorCallbackFactory,
  atoneFailedCallbackFactory,
  atoneSucceededCallbackFactory,
  configAtone,
  convertOrderHistoryProducts as convertOrderHistoryProductsForAtone,
  makeAtonePayment,
} from '@spa/services/atone'
import {
  configPaidy,
  convertOrderHistoryProducts as convertOrderHistoryProductsForPaidy,
  makePaidyPayload,
  paidyCallbackFactory,
  PaidyResponse,
} from '@spa/services/paidy'
import { Contact } from '@spa/store/modules/contact/types'
import { CreditcardModel } from '@spa/store/modules/creditcard/types'
import { typeIsCreditCard } from '@spa/store/modules/orderConfirm/types'
import {
  CreditCardPaymentMethod,
  Order,
  paymentMethodIsCreditCard,
  PaymentPoint,
} from '@spa/store/modules/orderHistory/types'
import { User } from '@spa/store/modules/user/types'
import { Either, left } from 'fp-ts/lib/Either'
import { fromNullable } from 'fp-ts/lib/Option'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

enum SubmitStatus {
  None,
  Running,
}

@Component({
  components: {
    PaymentEdit,
    SpaErrorDialog,
    ConfirmModal,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class ReorderPayment
  extends Mixins<PluginMixin & WithConfirmModal & HlAppModeMixin>(PluginMixin, WithConfirmModal, HlAppModeMixin) {

  pageStatus: Status = Status.Pending
  submitStatus: SubmitStatus = SubmitStatus.None

  paymentState: ReorderPaymentState = ReorderPaymentState.init()

  securityCode: string = ''

  showModal: boolean = false
  modalMessage: string = ''
  onCloseErrorModalCallback: (() => void) | undefined = undefined

  readonly paymentService = new PaymentService()
  readonly purchaseService = new PurchaseService()

  atoneScriptLoader: AtoneScriptLoader = new AtoneScriptLoader()

  paidyScriptLoader: PaidyScriptLoader = new PaidyScriptLoader()

  paidyHandler: PaidyHandler

  availablePaymentList: PaymentList = PaymentList.empty()
  provisionalOrderId: string | null = null
  commercePurchaseMenu: CommercePurchaseMenu | null = null

  sellerSalesOrder = new SellerSalesOrder()

  errorMessage: string = 'エラーが発生しました。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'

  atoneErrors: AtoneError[] = []

  get cardPaymentProviderConfig() {
    return getCreditcardPaymentProvierServiceConfig()
  }
  get cardPaymentProvider() {
    return this.cardPaymentProviderConfig.forPurchase
  }

  get isLoading() {
    return this.pageStatus === Status.Loading
  }

  get isPageCompleted(): boolean {
    return this.pageStatus === Status.Completed
  }

  get orderId(): string {
    const { id } = this.$route.params

    return id
  }

  get order(): Order {
    return this.$store.state.orderHistory.item
  }

  get orderStatusContext(): Context {
    return ContextFactory.fromStore(this.order).create()
  }

  get orderScope(): CartScopeEq {
    return this.order.cartScope
  }

  get orderIsBeforeCancellable(): boolean {
    return getIsBeforeCancellable(this.orderStatusContext)
  }

  get brandEnglishName(): string | null {
    return this.orderScope.kind.isBrand ? this.orderScope.value.toString() : null
  }

  get shipping(): number {
    return _.get(this.order.chargeSheet.delivery, 'priceIncludingTax.price', 0)
  }

  get paymentType(): PaymentType | undefined {
    return this.paymentState.paymentType
  }

  get paymentTypeIsCreditCard(): boolean {
    return typeIsCreditCard(this.paymentType || '')
  }

  get selectedPaymentOptionsValidation(): ErrorBag {
    return this.paymentState.selectedPaymentOptionsValidation
  }

  get discountAmount(): DiscountAmount {
    return convertFromStoreOrderHistoryToDiscountAmount(this.order)
  }

  /**
   * 注文レコードの適用されたポイント(payment.point)
   */
  get appliedPoints(): PaymentPoint | undefined {
    return this.order.payment.point
  }

  get serviceFee(): number | undefined {
    return fromNullable(this.order.chargeSheet.serviceFee).fold(
      (void 0),
      fee => fee.priceIncludingTax.price
    )
  }

  get contact(): Contact {
    const contactId = this.order.delivery.contactId
    const contact = this.order.delivery.contact

    return {
      id: contactId,
      country: contact.address.country,
      postal_code: contact.address.code,
      region: contact.address.region,
      locality: contact.address.locality,
      street_address: contact.address.street,
      first_name: contact.name.firstName,
      last_name: contact.name.lastName,
      tel: contact.tel,
      display_level: 0, // This is required but not used.
    }
  }

  get selectedPaymentTypeIsAllowed(): boolean {
    return this.paymentType ? this.availablePaymentList.isAvailablePayment(this.paymentType) : false
  }

  get selectedCard(): ApiCreditcard | null {
    return this.paymentState.selectedCard
  }

  get selectedCardId(): string | undefined {
    return _.get(this.selectedCard, 'id')
  }

  get creditcards(): CreditcardModel[] {
    return this.$store.state.creditcard.items
  }

  get creditcardError(): { load: Error|null } {
    return _.get(this.$store.state.creditcard, 'error')
  }

  get creditcardLoadError(): Error|null {
    return _.get(this.creditcardError, 'load', null)
  }

  get creditcardLoadFailed(): boolean {
    return this.creditcardLoadError !== null
  }

  get paymentParam(): any {
    // TODO: ParametersBuilderを使うようにしたい
    return {
      payment_type: this.paymentType,
      ...this.appliedPoints && { point: this.appliedPoints },
    }
  }

  get deliveryParam(): any {
    return {
      ...{
        delivery_type: 'registered',
        id: this.order.delivery.contactId,
        delivery_method: this.order.delivery.deliveryMethod,
      },
      ...this.order.delivery.date && {
        date: this.order.delivery.date,
      },
      ...this.order.delivery.timeSlot && {
        timeSlot: this.order.delivery.timeSlot,
      },
      ...this.order.delivery.unattendedDelivery && {
        unattended_delivery: this.order.delivery.unattendedDelivery,
      },
    }
  }

  get deliveryParamString(): string {
    return JSON.stringify(this.deliveryParam)
  }

  get user(): User {
    return this.$store.state.user.user
  }

  get adCode(): string | null {
    return adCodeStore.read().toNullable()
  }

  get showSecurityCode(): boolean {
    return this.paymentTypeIsCreditCard
      && this.cardPaymentProviderConfig.viewConfig.paymentForm.requireSecurityCode
  }

  get cancelUrl(): string {
    return `/mypage/order/${this.orderId}`
  }

  get registerCardLimit(): number | null {
    return this.cardPaymentProvider.registerCardLimit
  }

  get paymentEditViewModel(): PaymentEditViewModel {
    const factory = new PaymentEditViewModelFactory(
      this.availablePaymentList,
      this.creditcards,
      this.useCreditcard,
      this.removeCreditcard,
      this.navigateToNewCreditCard,
      this.showSecurityCode
    )
    if (this.paymentType) {
      factory.selectedPaymentId = this.paymentType
    }
    factory.selectedOptions = this.paymentState.selectedPayment.optionList
    factory.creditCardSelectedId = this.selectedCardId || ''
    factory.creditCardLoadFailed = this.creditcardLoadFailed
    factory.creditCardRegisterLimit = this.registerCardLimit
    factory.submitButtonLabel = 'お支払い方法を変更し再注文する'
    factory.cancelButtonLabel = '購入履歴に戻る'
    factory.showCancelButton = true

    return factory.create()
  }

  /**
   * NOTE: 配送方法によって特定の決済方法が選択出来ない場合があるので、そのロジックを実装するために使う
   * TODO: 美ラボ・ホテラバリリース後すぐにリファクタリングしてこのプロパティを削除する
   * @see: https://github.com/my-color/front/issues/5077
   */
  get deliveryMethod(): string {
    return this.order.delivery.deliveryMethod
  }

  onCloseErrorModal(): void {
    this.showModal = false

    if (this.onCloseErrorModalCallback) {
      this.onCloseErrorModalCallback()
      this.onCloseErrorModalCallback = undefined
    }
  }

  async initOrder(): Promise<void> {
    const { id } = this.$route.params

    await this.$store.dispatch('orderHistory/get', id)
  }

  async initCreditcards(): Promise<void> {
    await this.$store.dispatch('creditcard/load')
  }

  async initUser(): Promise<void> {
    await this.$store.dispatch('user/get')
  }

  async initPurchaseMenu() {
    const result = await this.purchaseService.getMenu()

    return result.map((value) => {
      this.commercePurchaseMenu = _.get(value, 'body.data')
    })
  }

  // TODO: Navigation guard against user status
  async created() {
    this.pageStatus = Status.Loading

    await this.$store.dispatch('user/get')

    await Promise.all([
      // User info is required for Atone modal. Basically user is already loaded before this page is rendered.
      this.initUser(),
      this.initCreditcards(),
      this.initOrder(),
    ])

    if (!this.order) {
      this.modalMessage = '購入履歴が取得できませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
      this.showModal = true
      this.pageStatus = Status.Failed

      return
    }

    const resultInitPurchaseMenu = await this.initPurchaseMenu()
    if (resultInitPurchaseMenu.isLeft()) {
      this.modalMessage = '購入履歴の表示中にエラーが発生しました'
      this.showModal = true
      this.pageStatus = Status.Failed

      return
    }

    await this.fetchAvailablePaymentList()

    /**
     * 再注文後にブラウザを戻るなどの操作でこのモーダルが表示されることがある
     * ユーザーは再注文を行ったのであってキャンセルを行ったという認識はないと思われるので、玉虫色な文言を表示する。
     * なお、すでにキャンセル済みの注文に対して /reorder/payment を表示する動線は存在しないので、
     * このモーダルが表示されるのはブラウザの履歴や開きっぱなしのタブからのアクセスのみになることを想定している。
     *
     * @see https://github.com/Everforth/growthpalette-front/issues/8063#issuecomment-2188226868
     */
    if (this.order.salesOrderStatus === 'cancel') {
      this.modalMessage = 'エラーが発生しました。<br/>購入履歴をご確認ください。'
      this.showModal = true
      this.pageStatus = Status.Failed
      this.onCloseErrorModalCallback = () => {
        this.$router.push('/mypage/order')
      }

      return
    }

    if (this.orderIsBeforeCancellable) {
      this.modalMessage = 'ご注文情報登録中は再注文できません'
      this.showModal = true
      this.pageStatus = Status.Failed

      return
    }

    // Set selected payment info
    await this.initPaymentType()

    await Promise.all([
      this.loadAtoneScript(),
      this.loadAndConfigPaidyScript(),
      this.loadCreditcardScript(),
    ])

    this.pageStatus = Status.Completed
  }

  /**
   * 現状の再注文は前回の支払い方法を選択できないようにしているので実質意味のない処理である。
   * ただ、再決済機能でも同じVueを利用する予定で、この場合は同じ決済方法を利用可能にする予定。
   * この際は元と同じ注文方法がデフォルトで選ばれていて良さそうなので実装は残しておく。
   * 例)
   * - PayPayで注文したがアプリを閉じてしまい決済が完了できない
   * - 注文履歴から再注文画面を開く
   * - PayPayで再注文を行う
   *   →PayPayが最初から選択されていることが望ましいのではないか
   */
  async initPaymentType(): Promise<void> {
    // When payment type is forbidden
    const found = this.findAvailablePayment(this.order.payment.method.kind)
    if (!found) {
      return
    }

    if (paymentMethodIsCreditCard(this.order.payment.method)) {
      await this.initPaymentTypeToCreditcard(this.order.payment.method)

      return
    }

    this.paymentState = this.paymentState.setSelectedPayment(found)
    CreateSelectOptionList.default().fromPaymentMethod(this.order.payment.method, found).fold(
      (e: Error) => { log.error(e) },
      (list: SelectOptionList) => {
        this.paymentState = this.paymentState.setSelectedOptionList(list)
      }
    )
  }

  async initPaymentTypeToCreditcard(paymentMethod: CreditCardPaymentMethod): Promise<void> {
    /**
     * 少なくともクロネコではidと前回支払いのtokenが一致することはないはずだが、
     * ひとまず既存実装を残しておくことにした。
     * @see https://github.com/Everforth/growthpalette-front/issues/7902
     */
    const originalOrderCreditcard = _.find(this.creditcards, ['id', paymentMethod.token])

    // 一致するクレジットカードがなければリストの先頭を利用する
    const headOfListCreditcard = this.creditcards[0] || undefined

    if (!originalOrderCreditcard && !headOfListCreditcard) {
      return
    }

    await this.useCreditcard(originalOrderCreditcard || headOfListCreditcard)()
  }

  async createProvisionalOrderIfNotExist(): Promise<Error | void> {
    if (this.provisionalOrderId) {
      return
    }

    const provisionalOrderIdResult = await this.purchaseService.createProvisionalOrderId()

    if (provisionalOrderIdResult.isLeft()) {
      return provisionalOrderIdResult.value
    }

    this.provisionalOrderId = provisionalOrderIdResult.value
  }

  async loadAtoneScript() {
    if (!this.findAvailablePayment('atone')) {
      return
    }

    const result = await this.atoneScriptLoader.loadScript()

    if (result.isSome()) {
      this.modalMessage = this.atoneScriptLoader.loadErrorMessage
      this.showModal = true

      return
    }
  }

  async atoneAuthenticatedCallback(authenticationToken: string, userNo: string): Promise<void> {
    return atoneAuthenticatedCallbackFactory(
      this.user.id,
      { authenticationToken, userNo },
      async () => { /* nothing */ },
      async () => {
        this.modalMessage = this.errorMessage
        this.showModal = true
      }
    )
  }

  /**
   * - エラーが発生した際にerror callbackが実行される
   *   - エラーの情報が引数として渡される
   *   - Frontはデフォルトの文言+エラーの情報に応じた文言でエラーモーダルを表示する
   * - atoneのモーダルを閉じる際にfailed callbackが実行されるケースがある
   *   - 引数なし
   *   - Frontはデフォルトの文言でエラーモーダルを表示する
   * したがって、failed callbackによって文言の上書きがされないように、
   * エラーの情報をVueコンポーネント内で保持することを選択した。
   *
   * @see https://github.com/my-color/growthpalette-pm/issues/195#issuecomment-1746058331
   *
   * 初回の注文時にatoneではNGとなる電話番号が配送先かアカウント情報のいずれかに登録されていた場合、再注文時にatoneを選択すると必ず電話番号エラーとなる。
   * 再注文時に配送先・アカウント情報は初回注文時のものが使い回され、アカウントサービスなどで情報を更新したとしても再注文には反映されないためである。
   * 頻度として高くないであろうことが推測されるので、お問い合わせベースの運用でのカバーの方針としている。
   * @see https://www.chatwork.com/#!rid264557914-1766882570315759616
   */
  storeAtoneErrorCodeAndMessage(errors: any[]) {
    this.atoneErrors = parseAtoneErrorCodeAndMessage(errors)
  }

  clearAtoneErrorCodeAndMessage() {
    this.atoneErrors = []
  }

  atoneCancelledCallback(): Promise<void> {
    this.submitStatus = SubmitStatus.None

    return atoneCancelledCallbackFactory(this.user.id)
  }

  atoneFailedCallback(response: any): Promise<void> {
    return atoneFailedCallbackFactory(
      this.user.id,
      response,
      async () => {
        this.modalMessage = atoneErrorMessages(this.errorMessage, this.atoneErrors)
        this.showModal = true
        this.submitStatus = SubmitStatus.None
      }
    )
  }

  async atoneSucceededCallback(response: any): Promise<void> {
    const actionOnSuccess = async () => {
      const { id } = response

      // TODO: ParametersBuilderを使うようにしたい
      const paymentParam =  {
        ...this.paymentParam,
        ...{
          paymentid: id,
          // atoneのモーダル内でログインが行われた場合も、
          // atoneAuthenticatedCallbackFactoryで更新されたpayment_auth_tokenが利用される
          auth_token: this.user.payment_auth_token,
        },
      }

      await this.reorderAndSideEffectToSubmitStatusAndNavigateToCompletePage(JSON.stringify(paymentParam))
    }

    return atoneSucceededCallbackFactory(this.user.id, response, actionOnSuccess)
  }

  async atoneErrorCallback(name: string, message: string, errors: any[]) {
    atoneErrorCallbackFactory(
      this.user.id,
      { name, message, errors },
      async () => {
        this.storeAtoneErrorCodeAndMessage(errors)
        this.modalMessage = atoneErrorMessages(this.errorMessage, this.atoneErrors)
        this.showModal = true
        this.submitStatus = SubmitStatus.None
      })
  }

  async processAtone(): Promise<void> {
    this.clearAtoneErrorCodeAndMessage()

    await this.createProvisionalOrderIfNotExist()

    if (!this.provisionalOrderId) {
      this.modalMessage =  this.errorMessage
      this.showModal = true
      this.submitStatus = SubmitStatus.None

      return
    }

    /**
     * TODO: サービス手数料
     * @see https://github.com/Everforth/growthpalette-front/issues/6264
     */
    const atonePaymentItems = convertOrderHistoryProductsForAtone(
      this.order.products,
      this.shipping,
      this.discountAmount
    )

    const atonePaymentResult = await makeAtonePayment(
      this.provisionalOrderId,
      this.user,
      this.contact,
      atonePaymentItems
    )

    if (atonePaymentResult.isLeft()) {
      this.modalMessage =  this.errorMessage
      this.showModal = true
      this.submitStatus = SubmitStatus.None

      return
    }

    configAtone(
      this.user.id,
      {
        preToken: this.user.payment_auth_token || '',
        payment: atonePaymentResult.value,
        authenticated: this.atoneAuthenticatedCallback,
        cancelled: this.atoneCancelledCallback,
        failed: this.atoneFailedCallback,
        succeeded: this.atoneSucceededCallback,
        error: this.atoneErrorCallback,
      }
    )

    Atone.start()

    return
  }

  findAvailablePayment(paymentId: string): Payment | null {
    return this.availablePaymentList.find(p => p.id === paymentId)
  }

  findAvailableCreditCard(): Payment | null {
    return this.availablePaymentList.find(p => typeIsCreditCard(p.id))
  }

  async loadAndConfigPaidyScript() {
    if (!this.findAvailablePayment('paidy')) {
      return
    }

    const result = await this.paidyScriptLoader.loadScript()

    if (result.isSome()) {
      this.modalMessage = this.paidyScriptLoader.loadErrorMessage
      this.showModal = true

      return
    }

    this.paidyHandler = configPaidy(this.paidyCallback)
  }

  async paidyCallback(response: PaidyResponse): Promise<void> {
    paidyCallbackFactory(response, this.paidyCallbackAction)
  }

  async paidyCallbackAction(response: PaidyResponse): Promise<void> {
    const { id, status } = response

    if (status === 'rejected') {
      this.modalMessage = this.errorMessage
      this.showModal = true
      this.submitStatus = SubmitStatus.None

      return
    }

    if (status !== 'authorized') {
      this.submitStatus = SubmitStatus.None

      return
    }

    // TODO: ParametersBuilderを使うようにしたい
    const paymentParam =  {
      ...this.paymentParam,
      ...{
        paymentid: id,
        auth_token: this.user.payment_auth_token,
      },
    }

    await this.reorderAndSideEffectToSubmitStatusAndNavigateToCompletePage(JSON.stringify(paymentParam))
  }

  async processPaidy(): Promise<void> {
    await this.createProvisionalOrderIfNotExist()

    if (!this.provisionalOrderId) {
      this.modalMessage =  this.errorMessage
      this.showModal = true
      this.submitStatus = SubmitStatus.None

      return
    }

    const items = convertOrderHistoryProductsForPaidy(
      this.order.products,
      this.discountAmount,
      {
        serviceFee: this.serviceFee,
      }
    )

    const payload = makePaidyPayload(
      this.provisionalOrderId,
      this.user,
      this.contact,
      items,
      this.shipping
    )

    this.paidyHandler.launch(payload)
  }

  async loadCreditcardScript() {
    await this.cardPaymentProvider.loadScript()
      .catch(() => {
        this.modalMessage = this.errorMessage
        this.showModal = true
      })
  }

  async processCreditcard(): Promise<void> {
    /**
     * Loadingにした後、エラー時のみローディングを止めているように見えるが
     * {@link reorderAndSideEffectToSubmitStatusAndNavigateToCompletePage} の内部でも
     * ページ状態を書き換えているので、正常系の変更は省略している
     *
     * Loadingへの書き換えは上記メソッド内部でも行っているが、クレジットカードでは上記メソッド呼び出し前に通信を待っている
     * つまりローディングの開始がその分遅れてしまうため、別途状態の書き換えを行っている
     * @see https://github.com/Everforth/growthpalette-front/issues/8085
     *
     * 現状ではページステータスの更新が各メソッド内部に隠蔽されており、ページステータスの更新が煩雑になっている
     * 更新が複数箇所で都度記述されているので、変更や追加の度に状態管理ミスが有り得る
     * 一方、atoneなど「コールバックが実行されたのをトリガーとしてローディングをON/OFFする」という非同期的な管理が必要なケースもあり、
     * トリガーの発火タイミングを一律に定めにくいところもある
     *
     * 改善するとしたら、以下のアプローチが有り得るか
     * - 各処理では状態更新の代わりにイベントをプッシュ、イベントをハンドルして状態更新をする
     *   - 「状態更新させたい箇所」と「状態更新処理」を分離し、後者については一元管理する
     * - コールバック経由といった非同期処理はatoneなど個別のモジュール側で隠蔽させ、Vueコンポーネントからは直接扱わない
     *   - Vueコンポーネントはatoneモジュール呼び出し時、「atone決済が開始した時のコールバック」として状態更新関数をモジュールに指定しておく
     *   - イメージ
     *     ```
     *     atone.newProcess({
     *        onStart: async () => {
     *          this.startLoading()
     *          return this.order()
     *        },
     *        onFinish: () => {
     *          this.endLoading()
     *        },
     *        onError: (error) => {
     *          this.endLoading({ message: error.message })
     *        }
     *     }).run()
     *     ```
     */
    this.pageStatus = Status.Loading
    const result = await this.createCreditcardPayment()
    if (result.isLeft()) {
      this.modalMessage = this.errorMessage
      this.showModal = true
      this.pageStatus = Status.Pending
      this.submitStatus = SubmitStatus.None

      return
    }
    /**
     * FIXME:
     * 通常の注文時の構築方法CreditcartdPaymentParamBuilderと共通化したい。
     * が、VuexのPaymentに依存しているため難しい。
     */
    const paymentParam =  {
      ...this.paymentParam,
      ...result.value,
    }

    await this.createProvisionalOrderIfNotExist()
    /** このメソッドの内部で{@link pageStatus}がさらに更新されている */
    await this.reorderAndSideEffectToSubmitStatusAndNavigateToCompletePage(JSON.stringify(paymentParam))

    return
  }

  async createCreditcardPayment(): Promise<Either<Error, CreditcardPayment>> {
    if (this.selectedCard === null) {
      return left(new Error('creditcard not selected yet'))
    }
    if (!this.paymentType || !typeIsCreditCard(this.paymentType)) {
      return left(new Error(`${this.paymentType} is not valid as credit card payment type.`))
    }

    return this.cardPaymentProvider.createPaymentPayload(
      {
        payment_type: this.paymentType,
      },
      this.selectedCard.withSecurityCode(this.securityCode),
      this.user
    )
  }

  async validateAll(): Promise<boolean> {
    return this.$validator.validateAll()
  }

  // TODO: Order.vueとの共通化
  async submit() {
    if (this.submitStatus === SubmitStatus.Running) {
      log.warn('submitStatus must not be running')

      return
    }

    this.submitStatus = SubmitStatus.Running

    // Validate fields
    const validated = await this.validateAll()

    if (!validated) {
      this.modalMessage = '入力内容が正しくありません'
      this.showModal = true
      this.submitStatus = SubmitStatus.None

      return false
    }

    // Validate payment type
    if (!this.paymentType) {
      this.modalMessage = 'お支払い方法が選択されていません'
      this.showModal = true
      this.submitStatus = SubmitStatus.None

      return
    }

    if (!this.selectedPaymentTypeIsAllowed) {
      this.modalMessage = 'このお支払い方法はご利用頂けません'
      this.showModal = true
      this.submitStatus = SubmitStatus.None

      return
    }

    if (this.paymentType === 'atone') {
      await this.processAtone()

      return
    }

    if (this.paymentType === 'paidy') {
      await this.processPaidy()

      return
    }

    if (this.paymentTypeIsCreditCard) {
      await this.processCreditcard()

      return
    }

    // その他の方法
    await this.processDefault()
  }

  /**
   * サーバー側に指定された方法で注文パラメータを構築する
   * Order.vueのsubmitDefaultに対応する
   */
  async processDefault() {
    if (!this.paymentState.selectedPayment.payment) {
      this.modalMessage = 'お支払い方法が選択されていません。'
      this.showModal = true
      this.submitStatus = SubmitStatus.None

      return
    }

    this.paymentState = this.paymentState.validatePaymentOptions()

    if (this.paymentState.selectedPaymentOptionsValidation.hasSomeError) {
      this.modalMessage = 'ご入力内容に不備があります。'
      this.showModal = true
      this.submitStatus = SubmitStatus.None

      return
    }

    await this.createProvisionalOrderIfNotExist()

    if (!this.provisionalOrderId) {
      this.modalMessage =  this.errorMessage
      this.showModal = true
      this.submitStatus = SubmitStatus.None

      return
    }
    const orderDisplayId = convertLongIdToDisplayId(this.provisionalOrderId)
    this.paymentState = this.paymentState.addVariableResource({
      user: this.user,
      orderDisplayId,
    })
    const makePaymentResult = makePaymentParam(this.paymentState, this.appliedPoints)
    if (makePaymentResult.isLeft()) {
      log.error(makePaymentResult.value)
      this.modalMessage =  this.errorMessage
      this.showModal = true
      this.submitStatus = SubmitStatus.None

      return
    }

    await this.reorderAndSideEffectToSubmitStatusAndNavigateToCompletePage(makePaymentResult.value)
  }

  /**
   * 1. 再注文リクエストの発行
   * 2. 再注文処理の状態を初期状態に戻す
   * 3. 完了ページへの遷移
   *
   * を一度に実行する.
   *
   * 複数の処理・責務を抱えており、再利用性・凝集度・拡張性全て損なわれているが、
   * 現状の実装ではこの関数に強く依存している処理が多数有るため、やむを得ずそのまま利用.
   *
   * TODO: この関数を分解するための前提として
   * 1. Atone/Paidyの完了待受をコールバックからPromiseに変更し、非同期処理をPromiseに統一
   * 2. 支払い方法それぞれについてパッケージ化し、独立させる
   * 3. submit()の処理としては
   *   1. 再注文処理状態の変更
   *   2. （パッケージ毎の）再注文処理呼び出し
   *   3. 再注文処理状態の初期化
   *   4. 完了画面への遷移
   *   というフローの実装に集中させる
   */
  async reorderAndSideEffectToSubmitStatusAndNavigateToCompletePage(payment: string): Promise<void> {
    this.pageStatus = Status.Loading

    try {
      const result = await this.reorder(payment)

      const redirected = this.redirectToPaymentIfNeed(result, this.paymentType)
      if (redirected) {
        // リダイレクトが実行された場合にも実際に遷移が完了するまでは
        // 後続の処理が実行されるので処理を中断する
        return
      }

      this.submitStatus = SubmitStatus.None
      this.pageStatus = Status.Completed

      if (this.hlAppMode.isViewedInHlAppWebView) {
        location.href = iosCustomUrlSchemes.orderComplete
      } else {
        this.$router.push(`/order/complete/${result.id}?scope=${toQuery(this.orderScope)}`)
      }
    } catch (err) {
      log.error({ err })
      this.modalMessage = this.errorMessage
      this.showModal = true

      this.pageStatus = Status.Failed
      this.submitStatus = SubmitStatus.None
    }
  }

  async reorder(payment: string): Promise<MinimumOrderResult> {
    if (!this.provisionalOrderId) {
      throw new Error('Cannot reorder because new order id is empty.')
    }

    const payload = {
      sales_order_id: this.provisionalOrderId,
      supercede_sales_order_id: this.order.id,
      payment,
      delivery: this.deliveryParamString,
      aux_string_3: convertLongIdToDisplayId(this.provisionalOrderId),
      memo: this.adCode,
      attachment: JSON.stringify(this.order.attachment),
      ...createTransferAuxDataOnReorder(this.order),
    }

    const result = await this.purchaseService.supercede(payload)

    if (result.isLeft()) {
      throw result.value
    }

    const order = result.value.body.data.salesOrders[0]

    if (this.order.isPreOrder) {
      await this.markAsPreOrder(order.sales_order_id)
    }

    return {
      id: order.sales_order_id,
      redirectHtml: order.payment.redirectHtml,
    }
  }

  useCreditcard(creditcard: CreditcardModel): () => Promise<void> {
    return async () => {
      const creditcardPayment = this.findAvailableCreditCard()

      if (!creditcardPayment) {
        return
      }
      this.paymentState = this.paymentState.setSelectedPayment(creditcardPayment)
      this.paymentState = this.paymentState.setSelectedCard(creditcard)
    }
  }

  removeCreditcard(creditcard: CreditcardModel): () => Promise<void> {
    return async () => {
      const confirmed = await this.confirm()
      if (!confirmed) {
        return
      }

      this.pageStatus = Status.Loading
      const { id: creditcardId } = creditcard

      await this.$store.dispatch('creditcard/remove', creditcardId)

      const errorOnRemove = _.find(this.$store.state.creditcard.items, ['id', creditcardId])

      if (errorOnRemove) {
        this.modalMessage = 'エラーが発生しました。<br/>クレジットカード情報が削除できませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
        this.showModal = true

        this.pageStatus = Status.Failed

        return
      }

      await this.$store.dispatch('creditcard/load', { force: true })

      // Update Vue data
      if (this.paymentType === 'creditcard' && this.selectedCardId === creditcardId) {
        this.paymentState = this.paymentState.unsetSelectedPayment().unsetSelectedCard()
      }

      this.pageStatus = Status.Completed
    }
  }

  navigateToNewCreditCard() {
    this.$router.push(`/mypage/order/${this.orderId}/reorder/creditcard`)
  }

  navigateToPreviousPage() {
    this.$router.push(this.cancelUrl)
  }

  /**
   * その名に反してクレジットカードの選択時にはこのメソッドは呼ばれないので注意
   * クレジットカード選択時にはuseCreditcardが実行される
   */
  onPaymentSelected(payment: Payment) {
    this.paymentState = this.paymentState.setSelectedPayment(payment).unsetSelectedCard()
  }

  onOptionSelected(option: SelectOption) {
    this.paymentState = this.paymentState.toggleOption(option)
  }

  onUpdateCreditcardSecurityCode(code: string) {
    this.securityCode = code
  }

  onPaymentEditError(message: string) {
    this.modalMessage = message
    this.showModal = true
  }

  private async fetchAvailablePaymentList() {
    const result = await this.paymentService.getByOrderId(this.orderId)

    if (result.isLeft()) {
      this.modalMessage = 'エラーが発生しました。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
      this.showModal = true

      return
    }

    this.availablePaymentList = PaymentList.valueOf(
      filterPaymentMethodBasedOnOriginalOrder(result.value, this.order)
    )
  }

  private async markAsPreOrder(salesOrderId: string) {
    return await this.sellerSalesOrder.appendTag(
      salesOrderId,
      [
        'mycolor.salesorder.preorder',
      ]
    )
  }

  private redirectToPaymentIfNeed(result: MinimumOrderResult, paymentType: PaymentType | undefined): boolean {
    // 注文完了後に呼ばれるので決済種別は必ずあることを期待する
    if (!paymentType) {
      return false
    }

    return createRedirectHtmlRenderer(
      paymentType,
      [result]
    ).render()
  }
}

/**
 * 再注文・再決済における注文結果を表す最小限のインタフェース
 */
interface MinimumOrderResult {
  id: string
  redirectHtml?: string
}
